module.exports = "<p>\n  exploracion works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// /Users/usuario/Desktop/Angular/Urbanos/src/app/exploracion/exploracion.component.html
// module id = ../../../../../src/app/exploracion/exploracion.component.html
// module chunks = main